
    import { Component } from 'vue-property-decorator';
    import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
    import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
    import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
    import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
    import { Chip, FormFields, FilterFields, TableHeaderModel } from  '@/models/repsol-template.model';
    import ComponentBase from '@/mixins/componentBase';
    import store from '@/store';
    import { UserIdentityModel } from '@/models/file-entities.model';

    @Component({
        name: 'EstrategiasPage',
        components: {
            RepsolFilterBarComponent,
            RepsolFilterChipsComponent,
            RepsolTableComponent,
            RepsolFormPopupComponent
        },
    })

    class EstrategiasPage extends ComponentBase {

      isOpenFilters = false;
      isOpenForm = false;
      formIsValid = true;
      formOnlyRead = false;
      isContraParte = false;
      administrador = false;
      isAdminCEN = false;

      productoAnterior = null;
      mesaAnterior = null;
    popupHeaderText = "";
            filterChips:Chip[] = [];

            filterFields : FilterFields[] =  [];

            formFields : FormFields[] = [];

            items:any[] = [];

            itemEdit:any = {};

            tableHeaders:TableHeaderModel[] = [];

            itemEliminar: any = {};

            showDialog = false;

            tableLoading = false;
                totalItems = 0;

                tableOptions = {
                page: 1,
                itemsPerPage: 10,
                sortBy: [] as string[],
                sortDesc: [] as boolean[],
            };

            constructor() {
                    super();
            }

     
            mesaFormField: FormFields;
            productoFormField: FormFields;
      
      
            lineaFormField: FormFields;
            tipoFormField: FormFields;
            estrategiaFormField: FormFields;

            mesaFilterField:any = {
                                label: 'common.desk',
                                name: 'mesaId',
                                as: 'selectlist',
                                model: '',
                                isDisabled: false,
                                isRequired: false,
                                items: this.maestroMesaBase,
                                multiple: true,
                    };



            mounted(){
                    this.getMaestroProducto();
                    this.getMaestroMesa().then(() => {
                        const userIdentity = (store.state as any).userIdentity.userIdentity as UserIdentityModel;
                        this.administrador = userIdentity.perfilId == 'ADM';
                        this.isAdminCEN = userIdentity.perfilId == 'CEN';

                        if (this.administrador) {
                            const deskFilter: FilterFields = {
                                label: 'common.desk',
                                name: 'mesaId',
                                as: 'selectlist',
                                model: '',
                                isDisabled: false,
                                isRequired: false,
                                items: this.maestroMesaEscritura,
                                multiple: true
                            };
                            this.filterFields.push(deskFilter);
                        }

                        this.getMaestroOperacionTipo();

                        this.lineaFormField =  {
                            label: 'common.line',
                            name: 'linea',
                            as: 'selectlist',
                            model: '',
                            isDisabled: false,
                            isRequired: false,
                            items: this.maestroEstrategiaLinea,
                            multiple: false,
                            canView: true,
                            cols: 3,
                        };
                        this.tipoFormField = {
                            label: 'common.type',
                            name: 'tipoId',
                            as: 'selectlist',
                            model: '',
                            isDisabled: false,
                            isRequired: false,
                            items: this.maestroOperacionTipo,
                            multiple: false,
                            canView: true,
                            cols: 3,
                        };

                        this.estrategiaFormField = {
                            label: 'common.strategy',
                            name: 'codigoEstrategia',
                            as: 'number',
                            model: '',
                            isDisabled: false,
                            isRequired: false,
                            canView: true,
                            cols: 5,
                        };

                        this.formFields = [
                            {
                                label: 'common.desks',
                                name: 'mesaId',
                                as: 'selectlist',
                                model: '',
                                isDisabled: false,
                                isRequired: true,
                                items: this.maestroMesaBase,
                                canView: true,
                                cols: 5,
                            },
                            {
                                label: 'common.name',
                                name: 'nombre',
                                as: 'text',
                                model: '',
                                isDisabled: false,
                                isRequired: true,
                                canView: true,
                                cols: 5,
                            },
                            {
                                label: 'common.year',
                                name: 'anio',
                                as: 'text',
                                model: '',
                                isDisabled: false,
                                isRequired: true,
                                canView: true,
                                cols: 2,
                            },
                            this.estrategiaFormField,
                            {
                                label: 'common.product',
                                name: 'productoId',
                                as: 'selectlist',
                                model: '',
                                isDisabled: false,
                                isRequired: true,
                                items: this.maestroProductoEscritura,
                                multiple: false,
                                canView: true,
                                cols: 5,
                            },
                            {
                                label: 'common.year_until',
                                name: 'anioHasta',
                                as: 'number',
                                model: '',
                                isDisabled: false,
                                isRequired: false,
                                canView: true,
                                cols: 2,
                            },
                            this.lineaFormField,
                            this.tipoFormField,
                            {
                                label: 'estrategias.daily_operation',
                                name: 'operacionDiaria',
                                as: 'radio',
                                model: '',
                                isDisabled: false,
                                isRequired: true,
                                items:this.maestroSiNo,
                                canView: true,
                                cols: 3,
                            },
                            {
                                label: 'common.active',
                                name: 'activo',
                                as: 'radio',
                                model: '',
                                isDisabled: false,
                                isRequired: true,
                                items:this.maestroSiNo,
                                canView: true,
                                cols: 3,
                            }
                        ];

                        this.filterFields = [
                            {
                                label: 'common.name',
                                name: 'nombre',
                                as: 'text',
                                model: '',
                                isDisabled: false,
                                isRequired: false
                            },
                            {
                                label: 'common.product',
                                name: 'productoId',
                                as: 'selectlist',
                                model: [],
                                isDisabled: false,
                                isRequired: false,
                                items: this.maestroProductoEscritura,
                                multiple: true
                            },
                            {
                                label: 'common.year',
                                name: 'anio',
                                as: 'text',
                                model: '',
                                isDisabled: false,
                                isRequired: true
                            },
                            {
                                label: 'common.strategy_code',
                                name: 'codigoEstrategia',
                                as: 'number',
                                model: '',
                                isDisabled: false,
                                isRequired: false
                            },
                            {
                                label: 'common.active',
                                name: 'activo',
                                as: 'radio',
                                model: '',
                                isDisabled: false,
                                isRequired: false,
                                items: this.maestroSiNo
                            }
                        ];

                        this.mesaFormField = this.formFields.find(f => f.name === 'mesaId')!;
                        this.productoFormField = this.formFields.find(f => f.name === 'productoId')!;

                        this.tableHeaders = [
                            { text: 'common.identifier', value: 'id', sortable: true, as:'number' },
                            { text: 'common.year', value: 'anio', sortable: true, as:'number' },
                            { text: 'common.desk', value: 'mesaId', sortable: true, as: 'select', items: this.maestroMesaBase },
                            { text: 'common.product', value: 'productoId', sortable: true, as: 'select', items: this.maestroProducto },
                            { text: 'common.strategy_code', value: 'codigoEstrategia', sortable: true, as: 'number' },
                            { text: 'common.name', value: 'nombre', sortable: true, as: 'text' },
                            { text: 'common.active', value: 'activo', sortable: true, as: 'select', items: this.maestroSiNo },
                            { text: '', value: 'actions', sortable: false, as:'', actions:[
                                { icon: 'mdi-close', name: 'eliminar' },
                                { icon: 'edit', name: 'editar' }
                            ] },
                        ];

                        this.getEstrategiasList();
                    });
                }

                   onTableOptionsChanged(options: any) {
                this.tableOptions = { ...options };
                this.getEstrategiasList();
                }

        async getEstrategiasList(){

            this.openSpinner("estrategias.cargarListado");

            this.items = [];
            const filtro: any = {};
            this.filterFields.forEach(f =>{
                if(f.model){
                    filtro[f.name] = f.model;
                }
            });

            const page = this.tableOptions?.page ?? 1;
            const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
            const sortBy = this.tableOptions?.sortBy ?? [];
            const sortDesc = this.tableOptions?.sortDesc ?? [];
            filtro.PageNumber = page || 1;
            filtro.PageSize = itemsPerPage || 10;

            if (sortBy && sortBy.length) {
                filtro.sortBy = sortBy[0];
                filtro.sortDesc = !!(sortDesc && sortDesc[0]);
            }
            const route = '/api/estrategia/list';
            this.post({ apiUrl: route, entity: filtro })
            .then(data => {
                if(this.isAdminCEN)
                {
                    data.forEach(x => {x.actions.editar = false; x.actions.eliminar = false})
                }
                console.log(data.items);
                if (Array.isArray(data.items)) {
                    this.items = data.items;
                    this.totalItems = data.totalCount ?? 0;
            } else {
                    this.items = data?.items ?? [];
                    this.totalItems = data?.totalCount ?? 0;
                }
            })
            .catch(error =>{
                this.mostrarKO("estrategias.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        nuevoElemento() : void {
            this.popupHeaderText = "estrategias.nuevoElemento";
            this.itemEdit = { mesaId : this.userIdentity.mesaId, activo:true, operacionDiaria:false };
            
            this.productoAnterior = null;
            this.mesaAnterior = null;

            if (this.mesaFormField) {
               this.mesaFormField.items = this.maestroMesaEscritura;
            }
            if (this.productoFormField) {
               this.productoFormField.items = this.maestroProductoEscritura;
            }

            if(!this.isContraParte){

                if(this.maestroMesaEscritura.length == 1){
                    this.itemEdit.mesaId = this.maestroMesaEscritura[0].id;
                    this.formFields[0].isDisabled = true;
                }else{
                    this.formFields[0].isDisabled = false;
                }
            }
            this.isOpenForm = true;
        }

        tableEventAction(action:string, item:any): void{
            switch (action) {
                case 'eliminar':
                    this.itemEliminar = item;
                    this.showDialog = true;
                  break;
                case 'editar':

                    this.popupHeaderText = "estrategias.editarElemento";
                    this.itemEdit = {};
                    this.productoAnterior = null;
                    this.mesaAnterior = null;
                    this.openSpinner("estrategias.cargar");

                    this.get({ apiUrl: `/api/estrategia/${item.id}`})
                          .then((response) => {
                                this.itemEdit = response;
                                this.itemEdit["$item_id"] = item.id;
                                
                                this.productoAnterior = this.itemEdit.productoId;
                                this.mesaAnterior = this.itemEdit.mesaId;

                            this.closeSpinner();
                            this.isOpenForm = true;
                          })
                          .catch(() => {
                            this.closeSpinner();
                            this.mostrarKO("estrategias.errorCargar");
                            this.getEstrategiasList();
                      });
                    break;
                default:
                    break;
            }
        }

      private eliminarEstrategia() {
        this.showDialog = false;
        this.openSpinner("estrategias.eliminarExitosa");
        this.delete({ apiUrl: `/api/estrategia`, entity: this.itemEliminar })
          .then(() => {
            // Manejar la respuesta si es necesario
            this.closeSpinner();
            this.mostrarOK("estrategias.eliminarExitosa");
            // Actualizar el listado después de la eliminación
            this.getEstrategiasList();
          })
          .catch(() => {
            this.closeSpinner();
            this.mostrarKO("estrategias.errorEliminar");
          });
      }

        formEventAction(action:string, item:any): void{
            switch (action) {
                case 'salvar':
                  if (item["$item_id"]) {
                       this.openSpinner("estrategias.actualizarElemento");
                      // Realizar la llamada a la API para actualizar el elemento
                      this.put({ apiUrl: `/api/estrategia/${item["$item_id"]}`, entity: item })
                          .then(() => {
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("estrategias.actualizacionExitosa");
                              this.getEstrategiasList();
                          })
                          .catch(() => {
                              // Manejar errores si es necesario
                              this.closeSpinner();
                              this.mostrarKO("estrategias.errorActualizacion");
                          });
                  } else {
                      // Crear y listado
                      // Aquí realizamos la llamada a la API para crear un nuevo elemento
                      this.openSpinner("estrategias.crearElemento");
                      this.post({ apiUrl: '/api/estrategia', entity: item })
                          .then(() => {
                              // Mostrar mensaje de éxito
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("estrategias.creacionExitosa");
                              this.getEstrategiasList();
                          })
                          .catch(() => {
                              // Manejar errores si es necesario
                              this.closeSpinner();
                              this.mostrarKO("estrategias.errorCreacion");
                          });
                  }

                  break;

                case 'cancelar':
                    this.isOpenForm = false;
                    break;
                case 'cambio':
                {
                  let mesaSeleccionada = this.maestroMesaBase.find(me => me.id == item.mesaId);
                  let contraparte = mesaSeleccionada != undefined && mesaSeleccionada.esContraparte;

                  if(contraparte){
                      item.linea = 1;
                      item.tipoId = 'c';
                  this.rulesForm.codigoEstrategia = [this.required(), this.maxLen(25)];

                  }else{
                    this.rulesForm.codigoEstrategia = [];
                  }
                  this.lineaFormField.isDisabled = contraparte;
                  this.tipoFormField.isDisabled = contraparte;
                  this.estrategiaFormField.isRequired = contraparte;
                  
                  // Mesa filtering when product is selected
                  if (item.productoId && item.productoId !== this.productoAnterior) {
                      this.post({
                          apiUrl: '/api/maestro/mesa/filtrado',
                          entity: { productoId: item.productoId }
                      }).then(mesasFiltradas => {
                          if (mesasFiltradas && Array.isArray(mesasFiltradas)) {
                                  if (mesasFiltradas.length === 0) {
                                      this.mesaFormField.items = [{ id: -1, nombre: this.$i18n.t("productos.sinMesaDisponible").toString(), disabled: true }] as any;
                                      item.mesaId = null;
                                  } else {
                                      this.mesaFormField.items = mesasFiltradas;
                                      if (item.mesaId && !mesasFiltradas.some(m => m.id === item.mesaId)) {
                                          item.mesaId = null;
                                      }
                                  }
                          }
                      }).catch(() => {
                              this.mesaFormField.items = this.maestroMesaEscritura;
                      });
                  }

                  // Produto filtering when mesa is selected
                  if (item.mesaId && item.mesaId !== this.mesaAnterior) {
                      if (this.productoFormField) {
                          this.post({
                              apiUrl: '/api/maestro/producto/filtrado',
                              entity: { MesaId: item.mesaId }
                          }).then(productosFiltrados => {
                              if (productosFiltrados && Array.isArray(productosFiltrados)) {
                                  if (productosFiltrados.length === 0) {
                                      this.productoFormField.items = [{ id: -1, nombre: this.$i18n.t("productos.sinProductoDisponible").toString(), disabled: true }] as any;
                                      item.productoId = null;
                                  } else {
                                      this.productoFormField.items = productosFiltrados;
                                      if (item.productoId && !productosFiltrados.some(p => p.id === item.productoId)) {
                                          item.productoId = null;
                                      }
                                  }
                              }
                          }).catch(() => {
                              this.productoFormField.items = this.maestroProductoEscritura;
                          });
                      }
                  }

                  // Reset options when fields are cleared
                  if (!item.mesaId && this.mesaAnterior) {
                      if (this.productoFormField) {
                          this.productoFormField.items = this.maestroProductoEscritura;
                      }
                  }

                  if (!item.productoId && this.productoAnterior) {
                      if (this.mesaFormField) {
                          this.mesaFormField.items = this.maestroMesaEscritura;
                      }
                  }

                  this.productoAnterior = item.productoId;
                  this.mesaAnterior = item.mesaId;
                    break;
                }

                default:
                    break;
            }
        }

        changeFilters(): void {
            this.filterChips.splice(0);
            this.filterFields.forEach(f =>{
                if(f.model){
                    if(Array.isArray(f.model)){
                        f.model.forEach(m =>{
                            this.filterChips.push({clave:`${f.name}-${m.id}`, valor:m.nombre, tooltip: f.label});
                        })
                    }
                    else
                    {
                        this.filterChips.push({clave:`${f.name}`, valor: f.model  as string, tooltip: f.label});
                    }
                }
            });

            this.isOpenFilters = false;
            this.getEstrategiasList();
        }

        removeChip(clave: string): void {
            if(clave){
                this.filterChips = this.filterChips.filter(c => c.clave != clave);

                var name = clave.split('-')[0];
                var field = this.filterFields.find(f => f.name == name);
                if(field){
                    if(Array.isArray(field.model)){
                        var id = clave.split('-')[1];
                        field.model = field.model.filter(m => m.id != id);
                    }
                    else
                    {
                        field.model = '';
                    }


                }
                this.getEstrategiasList();
            }
        }

        rulesForm = {
            nombre: [this.required(),this.maxLen(255)],
            anio: [this.required(),this.range(2000,3000)],
            productoId: [this.required()],
            operadorId: [this.required()],
            codigoEstrategia: [this.required(), this.maxLen(25)],
            activo: [this.required()],
            anioHasta: [this.range(2000,3000)],
            operacionDiaria: [this.required()],
        }
    }

        export default EstrategiasPage;
